import { useState, useEffect } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import { IoIosArrowUp } from "react-icons/io";
import { animateScroll } from "react-scroll";
import { connect } from "react-redux";

const InspectionFooter = ({
  showSecurityCheck,
}) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);

  const header = { fontSize: 24, fontWeight: "700", color: "#0451be" };
  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <>
      <div
        className={`footer-top ${showSecurityCheck ? "bottom-div" : ""}`}
        style={{ padding: "30px 0px 10px" }}
      >
        <Container>
          <Row className="footer-heading mb-3 d-flex justify-content-between align-items-center">
            <Col md={4} sm={12}>
              <div className="inspection-div">
                <button className="inspection-footer-button">
                  <a className="footer-link " href="/">
                    Visit website
                    <i
                      className="fa fa-arrow-circle-right set-inspection-arrow"
                      aria-hidden="true"
                    ></i>
                  </a>
                </button>
              </div>
            </Col>
            <Col md={4} sm={12}>
              <div className="inspection-div">
                <button className="inspection-footer-button">
                  <a
                    className="footer-link"
                    target="_blank"
                    href="tel:8002274357"
                  >
                    Contact us
                    <i
                      style={{ fontSize: "18px" }}
                      className="fa-solid fa-phone set-inspection-arrow"
                    />
                  </a>
                </button>
              </div>
            </Col>
            <Col md={4} sm={12}>
              <div className="inspection-div">
                <button className="inspection-footer-button">
                  <a
                    className="footer-link"
                    href="https://api.whatsapp.com/send?phone=978002274357"
                    target="_blank"
                  >
                    Whatsapp us
                    <i className="fa-brands fa-whatsapp set-inspection-arrow" />
                  </a>
                </button>
              </div>
            </Col>

          </Row>
        </Container>
      </div>
      {/* {!hideScrollToTop && (
        <button
          className={`scroll-top ${scroll > top ? "show" : ""}`}
          onClick={() => scrollToTop()}
        >
          <IoIosArrowUp />
        </button>
      )} */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    globalData: state.globalData,
    apiData: state.apiData,
    loginData: state.loginData,
    profile: state.profile,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(InspectionFooter);
